import { takeLatest, put, call } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as serviceCenter from 'utils/service-center';
import * as actionTypes from './constants';

import { userSuccess, userFailure } from './user-actions';

export function* fetchUser(action) {
  try {
    const results = yield call(callApi, {
      endpoint: 'user',
      options: {
        errorMessage: 'Could not get user data',
        retryAction: action,
      },
    });
    yield serviceCenter.getCachedServiceCenter() ||
      serviceCenter.cacheSelectedServiceCenter(results.defaultServiceCenter);

    yield put(userSuccess(results));
  } catch (err) {
    yield put(userFailure(err));
  }
}

export default function* watchSearchByType() {
  yield takeLatest(actionTypes.USER_REQUEST, fetchUser);
}
